import React, { useState } from 'react'
import Reviews from '@components/pages/components/Reviews'
import TrustpilotReviewsDrawer from '@components/product/TrustpilotReviewsDrawer'
import {
  formatDate,
  TrustpilotRatings,
  TrustpilotReview
} from '@api/trustpilot'
import styles from './styles.module.scss'

type Props = {
  ratings: TrustpilotRatings
  reviews: TrustpilotReview[]
  productType: string
}

export default function TrustpilotReviews({
  ratings,
  reviews,
  productType
}: Props) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (ratings.numberOfReviews.total === 0 || reviews.length === 0) return null

  const reviewsMap = Object.fromEntries(
    reviews.map((review, i) => [
      i,
      {
        stars: review.stars,
        description: review.content,
        author: review.consumer.displayName,
        date: formatDate(review.createdAt)
      }
    ])
  )

  const title = (
    <>
      <span className={styles.TrustpilotReviews__score}>
        {ratings.starsAverage.toFixed(1)}
      </span>
      <span className={styles.TrustpilotReviews__count}>
        Based on {ratings.numberOfReviews.total} reviews
      </span>
    </>
  )

  return (
    <>
      <Reviews
        title={title}
        reviews={reviewsMap}
        onReadMore={() => setDrawerOpen(true)}
      />
      <TrustpilotReviewsDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        ratings={ratings}
        initialReviews={reviews}
        productType={productType}
      />
    </>
  )
}
